import { useQuery } from '@tanstack/react-query';

import type { AdminWebhookHealth } from '../api/client';
import { useAdminAuth } from '../auth/AuthProvider';

export function WebhookHealthPage() {
  const { fetcher } = useAdminAuth();
  const { data, isLoading, error } = useQuery({
    queryKey: ['admin', 'webhooks', 'health'],
    queryFn: () => fetcher<AdminWebhookHealth>('/admin/api/webhooks/health'),
    refetchInterval: 15_000,
  });

  return (
    <div className="space-y-4">
      <h1 className="text-xl font-semibold">Webhook health</h1>
      {isLoading ? <div>Loading…</div> : null}
      {error ? <div className="card text-red-600">{(error as Error).message}</div> : null}
      {data ? (
        <div className="grid gap-3 sm:grid-cols-3">
          <Metric label="Queue depth" value={data.queue_depth} />
          <Metric label="Failed (pending retry)" value={data.failed_pending} />
          <Metric label="Exhausted (terminal)" value={data.exhausted} />
          <Metric label="Delivered (24h)" value={data.delivered_24h} />
          <Metric label="Attempts (24h)" value={data.attempts_24h} />
          <Metric
            label="Failure rate (24h)"
            value={`${(data.failure_rate_24h * 100).toFixed(2)}%`}
          />
        </div>
      ) : null}
    </div>
  );
}

function Metric({ label, value }: { label: string; value: number | string }) {
  return (
    <div className="card">
      <div className="text-xs uppercase text-slate-500">{label}</div>
      <div className="text-2xl font-semibold">{value}</div>
    </div>
  );
}
